import { Directive } from '@angular/core';
import { Validators } from '@angular/forms';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[emailValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }]
})
export class EmailValidatorDirective implements Validator {

  validate(control: FormControl): ValidationErrors {
    const errors = Validators.email(control);

    return errors ? {
      'email': {
        'message': 'Please enter a valid email.'
      }
    } : null;
  }
}
